module.exports = __webpack_public_path__ + "img/mw.dc4b1545.svg";